module.exports = __webpack_public_path__ + "img/user-premium.535853ed.svg";